module.exports = __webpack_public_path__ + "static/img/nuestras-plantas.9c65655.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestras-plantas-en/nuestras-plantas.jpg
// module id = CEc7
// module chunks = 0